import React from 'react';
import { Dropdown } from 'react-bootstrap';
import Icon from '../../../../../../../../../shared/design-system/components/atoms/icon';

type Action = {
  key: string;
  displayName: string;
  SVGIcon?: React.ReactNode;
};

type Props = {
  actions: Action[];
  onActionClick: (actionKey: string) => void;
};

const ActionsDropdown: React.FC<Props> = ({
  actions,
  onActionClick,
}) => {
  if (!actions?.length) return null;

  return (
    <div className="grid-action">
      <Dropdown bsPrefix="dropdown-custom" drop="down">
        <Dropdown.Toggle
          bsPrefix="dropdown-toggle-custom"
          variant="dropdown-custom"
          id="actions-dropdown"
        >
          <Icon identifier="more-vertical-alt" />
        </Dropdown.Toggle>

        <Dropdown.Menu bsPrefix="dropdown-menu-custom">
          {actions.map((action) => (
            <Dropdown.Item
              key={action.key}
              bsPrefix="dropdown-item-custom"
              onClick={() => onActionClick(action.key)}
            >
              {action.SVGIcon && (
                <span className="lfloat gray-txt-6">
                  {action.SVGIcon}
                </span>
              )}
              <span className="gray-txt-10">{action.displayName}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ActionsDropdown;
